module.exports = __webpack_public_path__ + "static/media/benefit_2.d32d79cc.jpg";